<page-toolbar [title]="title"></page-toolbar>

<page-content>
  <data-table
    (custom)="onCustom($event)"
    [columns]="columns"
    [dataProviderParams]="params"
    [dataProvider]="applicationVersionsService"
    [validator]="{ validate: 'versionTags',  target: 'versionTags', inverse: true}"
    alternative_icon="block"
    icon="add_circle"
    title="Versions"
  >
  </data-table>
</page-content>
